import AppService from '../shared/App.api';

export default {
  createAlert,
};

const alertsEndpoint = '/admin/alerts';

async function createAlert(alert) {
  const response = await AppService.post(alertsEndpoint, alert);
  return response.data;
}
